module.exports = __webpack_public_path__ + "static/media/shop_accessories.c1dc720e.png";